import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/home/logo-knowage8.svg'
import _imports_1 from '../assets/images/home/kn_arrow_right.svg'
import _imports_2 from '../assets/images/home/kn_bubble.svg'
import _imports_3 from '../assets/images/home/kn_add.svg'
import _imports_4 from '../assets/images/home/kn_flag.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-94b16890")

_pushScopeId("data-v-94b16890")
const _hoisted_1 = {
  key: 1,
  class: "homeContainer"
}
const _hoisted_2 = { class: "upperSection p-d-flex" }
const _hoisted_3 = { class: "p-d-flex p-flex-column kn-flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_5 = { class: "text p-grid" }
const _hoisted_6 = { class: "p-col-12 p-m-0" }
const _hoisted_7 = { class: "buttons p-d-flex" }
const _hoisted_8 = {
  href: "https://knowage-suite.readthedocs.io/",
  target: "_blank"
}
const _hoisted_9 = {
  href: "https://www.knowage-suite.com/qa/",
  target: "_blank"
}
const _hoisted_10 = { class: "lowerSection" }
const _hoisted_11 = { class: "border-container" }
const _hoisted_12 = { class: "image" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_14 = { class: "image" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_16 = { class: "image" }
const _hoisted_17 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_18 = { class: "image" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.homePage.loading && _ctx.homePage.label && _ctx.completeUrl)
      ? (_openBlock(), _createBlock("iframe", {
          key: 0,
          src: `${_ctx.completeUrl}`
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    (!_ctx.homePage.loading && !_ctx.homePage.label)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('home.welcome')), 1),
                _createVNode("p", {
                  class: "p-col-12 p-xl-6 p-m-0",
                  innerHTML: _ctx.$t('home.welcomeText')
                }, null, 8, ["innerHTML"])
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('home.button.documentation')), 1),
              _createVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('home.button.qa')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("p", null, _toDisplayString(_ctx.$t('home.connectYourData')), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("p", null, _toDisplayString(_ctx.$t('home.queryYourData')), 1)
              ]),
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("p", null, _toDisplayString(_ctx.$t('home.createYourAnalysis')), 1)
              ]),
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("p", null, _toDisplayString(_ctx.$t('home.saveAndShare')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})